import React from 'react';
import { BsFillXCircleFill } from 'react-icons/bs';
import { Navigate } from 'react-router-dom';
import { Database } from '../../server/database';
import { Server } from '../../server/server';
import { getAssetImage } from '../util/util';
import AlertModal from './AlertModal';
import GiftAssetModal from './GiftAssetModal';
import MessageModal from './MessageModal';
import './Modal.css'
import OpenPackModal from './OpenPackModal';
import QuestionModal from './QuestionModal';
import UserListModal from './UserListModal';
import './ViewAssetModal.css'

interface ViewAssetModalProps {
  asset: string;
  onClose: Function;
}

interface ViewAssetModalState {
  openUserList: boolean;
  userList: any[];
  openGiftAsset: boolean;
  giftFriend: string;
  openPack: boolean;
  openPackAssets: any[];
  navigate: string;
  message: string;
  alert: string;
  question: string;
}

class ViewAssetModal extends React.Component<ViewAssetModalProps, ViewAssetModalState> {
  constructor(props: ViewAssetModalProps) {
    super(props);

    this.state = {
      openUserList: false,
      userList: [],
      openGiftAsset: false,
      giftFriend: '',
      openPack: false,
      openPackAssets: [],
      navigate: '',
      message: '',
      alert: '',
      question: '',
    }

    this.onCloseUserList = this.onCloseUserList.bind(this);
    this.onCloseGiftAsset = this.onCloseGiftAsset.bind(this);
  }

  onPlayMatchBlitz() {
    this.setState({navigate: '/game/matcha-blitz'});
  }

  onPlayWhacka() {
    this.setState({navigate: '/game/whacka'});
  }

  onSetBanner() {
    this.setState({message: 'Setting banner...'});
    setTimeout(async () => {
      await Server.user.setBanner(this.props.asset);
      this.setState({navigate: '/profile/' + Server.user.getSlug(), message: ''});
    }, 500);
  }

  onSetPortrait() {
    this.setState({message: 'Setting portrait...'});
    setTimeout(async () => {
      await Server.user.setPortrait(this.props.asset);
      this.setState({navigate: '/profile/' + Server.user.getSlug(), message: ''});
    }, 500);
  }

  onSend() {
    let friends = Server.user.getFriends();
    let userList = [];
    for(let i = 0; i < friends.length; i++)
      userList.push(friends[i].id);
    this.setState({openUserList: true, userList: userList})
  }

  onCloseUserList(friend:string) {
    console.log(friend);
    this.setState({openUserList: false});
    if(friend) 
      this.setState({openGiftAsset: true, giftFriend: friend})
  }

  onCloseGiftAsset(sent:boolean) {
    this.setState({openGiftAsset: false});
    if(sent)
      this.props.onClose();
  }

  onBurn() {
    this.setState({alert: 'You will eventually be able to burn assets but not quite yet.'});
  }

  onOpenPack() {
    let asset = Database.getAsset(this.props.asset);
    this.setState({question: 'Are you sure you want to open the ' + asset.name + '?'});
  }

  onQuestionYes() {
    this.setState({question: '', message: 'Opening pack...'});

    setTimeout(async () => {
      let response = await Server.user.openPack(this.props.asset);

      this.setState({message: ''});

      if(response.success) {
        let pack = Database.getAsset(this.props.asset);
        if(pack.category == 'currency') 
          this.setState({alert: 'Coins added to your account.'});
        else
          this.setState({openPack: true, openPackAssets: response.assets});
      }
      else
        this.setState({alert: response.message});
    }, 500);
  }

  onCloseOpenPack() {
    this.setState({openPack: false, openPackAssets: []});
    let asset = Server.user.getAsset(this.props.asset);
    if(!asset)
      this.props.onClose();
  }

  onAlertClose() {
    this.setState({alert: ''});
    let asset = Server.user.getAsset(this.props.asset);
    if(!asset)
      this.props.onClose();
  }

  render() {
    if(this.state.navigate) 
      return <Navigate to={this.state.navigate} />;
      
    if(this.props.asset == '')
      return (null);

    if(this.state.openUserList) {
      return (
        <UserListModal open={this.state.openUserList} title={'Select Friend'} users={this.state.userList} onClose={this.onCloseUserList} />
      )
    }

    if(this.state.openGiftAsset) {
      return (
        <GiftAssetModal open={this.state.openGiftAsset} friend={this.state.giftFriend} asset={this.props.asset} onClose={this.onCloseGiftAsset} />
      )
    }

    if(this.state.openPack) {
      return (
        <OpenPackModal open={this.state.openPack} assets={this.state.openPackAssets} onClose={()=>this.onCloseOpenPack()}/>
      )
    }

    let asset = Database.getAsset(this.props.asset);
    let userAsset = Server.user.getAsset(this.props.asset);

    let imageClass = 'view-asset-modal-image';
    if(asset.category == 'banner') 
      imageClass = 'view-asset-modal-banner-image'

    let imageSrc = getAssetImage(asset);

    return (
      <div className="modal open">
        <div className="modal-content view-asset-modal-content">
          <button className="modal-close-button" onClick={()=>this.props.onClose()}>
            <BsFillXCircleFill />
          </button>
          <div className="view-asset-modal-header">{asset.name}</div>
          <div style={{display: 'flex', justifyContent: 'center'}}>
            <div style={{position: 'relative'}}>
              <img className={imageClass} src={imageSrc}></img>
              {userAsset && userAsset.quantity > 1 && 
                <div className="view-asset-modal-quantity">x{userAsset.quantity}</div>
              }
            </div>
          </div>
          <div className="view-asset-modal-description">
            {asset.description}
          </div>

          {asset.type == 'pack' &&
            <button onClick={()=>this.onOpenPack()}>Open Pack</button>
          }

          {asset.type == 'consumable' && asset.category =='whacka' &&
            <button onClick={()=>this.onPlayWhacka()}>Play Whacka</button>
          }

          {asset.type == 'consumable' && asset.category =='matcha-blitz' &&
            <button onClick={()=>this.onPlayMatchBlitz()}>Play Matcha Blitz</button>
          }

          {asset.type == 'cosmetic' && asset.category =='banner' &&
            <button onClick={()=>this.onSetBanner()}>Set Profile Banner</button>
          }

          {asset.type == 'cosmetic' && asset.category == 'portrait' &&
            <button onClick={()=>this.onSetPortrait()}>Set Profile Portrait</button>
          }

          <button onClick={()=>this.onSend()}>Send to Friend</button>

          <button onClick={()=>this.onBurn()}>Burn</button>
        </div>

        <MessageModal message={this.state.message}/>
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.onAlertClose()} />
        <QuestionModal message={this.state.question} onYes={()=>this.onQuestionYes()} onNo={()=>this.setState({question: ''})}/>
      </div>
    )
  }
}

export default ViewAssetModal;